<template>
    <div class="flex gap-4">
        <Card class="flex-1">
            <template #header>
                <h6 class="text-center">{{ $t('messages.admin.realEstate.lastQueries') }}</h6>
            </template>
            <template #content>
                <DataTable striped small hover :value="realEstateData" :fields="realEstateDataFields">
                    <Column v-for="field in realEstateDataFields" :key="field.key" :field="field.key" :header="field.label">

                        <template #body="slotProps">
                            <span v-if="field.key == 'price'">{{ slotProps.data.price }}€</span>
                            <span v-else>{{ slotProps.data[field.key] }}</span>
                        </template>
                    </Column>
                </DataTable>
            </template>
        </Card>

        <Card class="flex-1">
            <template #header>
                <h6 class="text-center">{{ $t('messages.admin.realEstate.lastQueriesMonth') }}</h6>
            </template>
            <template #content>

                <div>
                    <Button v-for="[key, value] in statMonths" :key="key"
                            :severity="selectedMonth==key ?'primary': 'secondary'" outlined class="m-1"
                            @click="setStatMonth(key, value)" size="sm">
                        {{ key }}
                    </Button>
                </div>
                <div>
                    <DataTable v-if="realEstateDataByMonth.length > 0" striped small hover :value="realEstateDataByMonth"
                            :fields="realEstateDataByMonthFields">
                        <Column field="expense" header="Kulud">
                            <template #body="slotProps">
                                {{ slotProps.data.expense }}€
                            </template>
                        </Column>
                    </DataTable>
                </div>
                <div v-if="dataLoading" class="text-center">
                    <ProgressSpinner large></ProgressSpinner>
                </div>
                <div v-else-if="realEstateDataByMonth.length==0" class="text-center">
                    <Button severity="secondary" large>{{ $t('messages.admin.realEstate.noResults') }}</Button>
                </div>
            </template>
        </Card>
    </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

onMounted(() => {
  getCompanies()
  getLatestQueries()
  initializeMonth()
})

const companies = ref([])
const statsByCompany = ref([])
const selectedMonth = ref('')
const realEstateData = ref([])
const realEstateDataByMonth = ref([])
const realEstateDataByMonthFields = ref([
  {
    key: 'company',
    label: t('messages.admin.realEstate.company'),
  },
  {
    key: 'expense',
    label: t('messages.admin.realEstate.expense'),
  },
])
const realEstateDataFields = ref([
  {
    key: 'name',
    label: t('messages.admin.realEstate.name'),
  },
  {
    key: 'company',
    label: t('messages.admin.realEstate.company'),
  },
  {
    key: 'service',
    label: t('messages.admin.realEstate.service'),
  },
  {
    key: 'price',
    label: t('messages.admin.realEstate.price'),
  },
  {
    key: 'keyword',
    label: t('messages.admin.realEstate.keyword'),
  },
  {
    key: 'created_at',
    label: t('messages.admin.realEstate.created_at'),
  },
])

const dataLoading = ref(false)
const months = ref([
  'Jaanuar',
  'Veebruar',
  'Märts',
  'Aprill',
  'Mai',
  'Juuni',
  'Juuli',
  'August',
  'September',
  'Oktoober',
  'November',
  'Detsember',
])

const getLatestQueries = async () => {
  await axios.get(route('real-estate.stats')).then(response => {
    realEstateData.value = response.data
  })
}

const getCompanyStats = async monthDate => {
  dataLoading.value = true
  await axios
    .get(route('real-estate.stats-by-month', { statDate: monthDate }))
    .then(response => {
      realEstateDataByMonth.value = response.data
      dataLoading.value = false
    })
    .catch(error => {
      if (error.response) {
        console.log(error.response)
      }
    })
}

const getCompanies = async () => {
  await axios.get(route('admin.company.index')).then(response => {
    companies.value = response.data.companies
  })
}

const setStatMonth = (month, monthDate) => {
  selectedMonth.value = month
  getCompanyStats(monthDate)
}

const initializeMonth = () => {
  const today = new Date()
  const key = months.value[today.getMonth()] + ' ' + today.getFullYear()
  const monthDate =
    today.getFullYear() +
    '-' +
    String(today.getMonth() + 1).padStart(2, '0') +
    '-01'
  setStatMonth(key, monthDate)
}

const statMonths = computed(() => {
  const result = new Map()
  for (let i = 0; i < 12; i++) {
    const newDate = new Date()
    newDate.setMonth(newDate.getMonth() - i)
    const formattedDate =
      newDate.getFullYear() +
      '-' +
      String(newDate.getMonth() + 1).padStart(2, '0') +
      '-01'
    const key = months.value[newDate.getMonth()] + ' ' + newDate.getFullYear()
    result.set(key, formattedDate)
  }
  return result
})
</script>

